// Remembers the brand the user last opened so the app root can reopen it.
// localStorage access is guarded — private mode / blocked storage degrades to
// "no remembered brand", never a crash.
const STORAGE_KEY = "pilot:last-brand-slug";

export function readLastBrandSlug(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeLastBrandSlug(slug: string) {
  try {
    localStorage.setItem(STORAGE_KEY, slug);
  } catch {
    // storage unavailable — the root will fall back to the dashboard
  }
}

export function clearLastBrandSlug() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage unavailable — nothing to clear
  }
}

/**
 * Where the app root should send the user: the remembered brand when they
 * still have access to it, the only brand when there is exactly one, and the
 * portfolio dashboard otherwise.
 */
export function homePathFor(brandSlugs: readonly string[], lastSlug: string | null): string {
  if (lastSlug && brandSlugs.includes(lastSlug)) return `/${lastSlug}`;
  if (brandSlugs.length === 1) return `/${brandSlugs[0]}`;
  return "/dashboard";
}
